import { REMOVE_SELECTED_USER, SELECT_USER, REMOVE_ALL_SELECTED_USERS } from '../action-types';

export const initialState = {
  data: []
};

export const customerUsersExternalSelectionReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SELECT_USER:
      return {
        ...state,
        data: [...state.data, action.user],
        isFetching: false
      };
    case REMOVE_SELECTED_USER:
      return {
        ...state,
        data: state.data.filter(i => i.userId !== action.user.userId)
      };

    case REMOVE_ALL_SELECTED_USERS:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
